export const visit = (vm, at) => {
at({ "fi": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "P\xE4ivit\xE4" ), " suorittaaksesi t\xE4m\xE4n toiminnon." ); } } } });
};